export default {"src":"/_next/static/media/0x7e7e112a68d8d2e221e11047a72ffc1065c38e1a.ce583e10.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};